'use strict';

module.exports = /* @ngInject */ function(uniteService) {
    return uniteService.formatPrice;
}
